module.exports = __webpack_public_path__ + "/images/3ffCAPw.jpg";


// WEBPACK FOOTER //
// ./src/app/images/kawo-qr.jpg